import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const { t } = useLanguage();
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = hash?.split('session_id=')[1]?.split('&')[0];
    if (!sessionId) { navigate('/'); return; }

    (async () => {
      try {
        const res = await axios.post(`${API}/api/auth/google-session`, { session_id: sessionId }, { withCredentials: true });
        if (res.data?.token && res.data?.user) {
          localStorage.setItem('ct_token', res.data.token);
          localStorage.setItem('ct_user', JSON.stringify(res.data.user));
          window.dispatchEvent(new Event('ct_auth_change'));
          navigate('/', { replace: true, state: { user: res.data.user } });
        } else {
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/', { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-cream dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-4 border-navy border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-sm text-gray-500">Completing sign in...</p>
      </div>
    </div>
  );
}
